import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import AppHeader from "../components/AppHeader";

function HeaderPerfil() {
  const { uid } = useParams();
  const [userName, setUserName] = useState("");

  useEffect(() => {
    if (!uid) return;
    const fetchUserData = async () => {
      try {
        const userDocSnapshot = await getDoc(doc(db, "users", uid));
        if (userDocSnapshot.exists()) {
          setUserName(userDocSnapshot.data().displayName || "Usuario");
        }
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    };
    fetchUserData();
  }, [uid]);

  return <AppHeader variant="back" title={userName} />;
}

export default HeaderPerfil;
